<ng-container *transloco="let t">
<div class="container">
  <div class="card mt-10">
    <div class="card-header px-4 d-flex align-items-center justify-content-between border-bottom-2">
      <h4 class="mb-0 mt-4">
        {{ t('portal.referAFriend.title') }}
        @if (sanitizedReferralContent) {
          <div class="fs-8 fw-bold mt-2"
            [innerHtml]="sanitizedReferralContent"></div>
        }
      </h4>
    </div>
    <form #referAFriendForm="ngForm" novalidate class="form-horizontal">
      <div class="card-body p-0">
        <div class="row m-2 p-2">
          <div class="form-group mb-5 col-md-6">
            <label class="form-label" for="referralType">{{ t('portal.referAFriend.iWouldLikeToRefer') }}</label>
            <select class="form-select" [(ngModel)]="req.referralType" name="referralType" required
              (ngModelChange)="onReferralTypeChange()"
              #referralTypeInput="ngModel" [ngClass]="{
            'is-invalid':
              referralTypeInput &&
              referralTypeInput.touched &&
              referralTypeInput.invalid
          }">
              @for (r of referralTypes; track r) {
                <option [ngValue]="r">{{ r }}</option>
              }
            </select>
            <div class="invalid-feedback">{{ t('portal.referAFriend.fieldRequired') }}</div>
          </div>
          <div class="form-group mb-5 col-md-6">
            <label class="form-label" for="referToUserId">{{ t('portal.referAFriend.iAmReferringThis') }} {{ req.referralType }} {{ t('portal.referAFriend.to') }}</label>
            <select class="form-select" [(ngModel)]="req.referToUserId" name="referToUserId" required
              #referToUserIdInput="ngModel" [ngClass]="{
            'is-invalid':
              referToUserIdInput &&
              referToUserIdInput.touched &&
              referToUserIdInput.invalid
          }">
              @for (agent of agents; track agent.userId) {
                <option [ngValue]="agent.userId">
                  {{ agent.firstName }} {{ agent.lastName }}
                </option>
              }
            </select>
            <div class="invalid-feedback">{{ t('portal.referAFriend.fieldRequired') }}</div>
          </div>
          <div class="form-group mb-5 col-md-6">
            <label class="form-label" for="firstName">{{ t('portal.referAFriend.firstName') }}</label>
            <input type="text" class="form-control" [(ngModel)]="req.firstName" name="firstName" required
              #firstNameInput="ngModel" [ngClass]="{
            'is-invalid':
              firstNameInput && firstNameInput.touched && firstNameInput.invalid
          }" />
            <div class="invalid-feedback">{{ t('portal.referAFriend.fieldRequired') }}</div>
          </div>
          <div class="form-group mb-5 col-md-6">
            <label class="form-label" for="lastName">{{ t('portal.referAFriend.lastName') }}</label>
            <input type="text" class="form-control" [(ngModel)]="req.lastName" name="lastName" />
          </div>
          <div class="form-group mb-5 col-md-6">
            <label class="form-label" for="phoneNumber">{{ t('portal.referAFriend.phoneNumber') }}</label>
            <input type="tel" class="form-control" [(ngModel)]="req.phone" name="phoneNumber" [mask]="'(000) 000-0000'" [showMaskTyped]="true" />
          </div>
          <div class="form-group mb-5 col-md-6">
            <label class="form-label" for="emailAddress">{{ t('portal.referAFriend.emailAddress') }}</label>
            <input type="email" class="form-control" [(ngModel)]="req.email" name="emailAddress" />
          </div>
          <div class="form-group mb-5 col-md-12">
            <label class="form-label" for="note">{{ t('portal.referAFriend.note') }}</label>
            <textarea class="form-control" rows="5" [(ngModel)]="req.note" name="note"></textarea>
          </div>
          @if (isAgentPortal && req.referralType === ReferralType.Borrower) {
            <div class="form-group mb-5 col-md-6">
              <label class="form-label" for="loanPurpose">{{ t('portal.referAFriend.loanPurpose') }}</label>
              <select class="form-select" id="loanPurpose" [(ngModel)]="req.loanPurpose" name="loanPurpose">
                <option [ngValue]="undefined">{{ t('portal.referAFriend.selectOne') }}</option>
                <option [ngValue]="'Purchase'">{{ t('portal.referAFriend.purchase') }}</option>
                <option [ngValue]="'Refinance'">{{ t('portal.referAFriend.refinance') }}</option>
              </select>
            </div>
            <div class="form-group mb-5 col-md-6">
              <label class="form-label" for="loanRequestPurpose">{{ t('portal.referAFriend.goalOfLoan') }}</label>
              <input type="text" class="form-control" id="loanRequestPurpose" [(ngModel)]="req.loanRequestPurpose" name="loanRequestPurpose" />
            </div>
            <div class="form-group mb-5 col-md-12">
              <label class="form-label" for="subjectPropertyAddress">{{ t('portal.referAFriend.subjectPropertyAddress') }}</label>
              <address-autocomplete-v2
                id="subjectPropertyAddress"
                [name]="'subjectPropertyAddress'"
                [(ngModel)]="subjectPropertyAddress"
                [placeholder]="t('portal.referAFriend.subjectPropertyAddress')"
                (addressSelected)="onSubjectPropertyAddressSelected($event)">
              </address-autocomplete-v2>
            </div>
            <div class="form-group mb-5 col-md-4">
              <label class="form-label" for="subjectPropertyCity">{{ t('portal.referAFriend.city') }}</label>
              <input type="text" class="form-control" id="subjectPropertyCity" [(ngModel)]="req.subjectPropertyCity" name="subjectPropertyCity" />
            </div>
            <div class="form-group mb-5 col-md-4">
              <label class="form-label" for="subjectPropertyState">{{ t('portal.referAFriend.state') }}</label>
              <select class="form-select" id="subjectPropertyState" [(ngModel)]="req.subjectPropertyState" name="subjectPropertyState">
                <option [ngValue]="undefined">{{ t('portal.referAFriend.selectOne') }}</option>
                @for (s of states; track s.value) {
                  <option [ngValue]="s.value">{{ s.name }}</option>
                }
              </select>
            </div>
            <div class="form-group mb-5 col-md-4">
              <label class="form-label" for="subjectPropertyZip">{{ t('portal.referAFriend.zip') }}</label>
              <input type="text" class="form-control" id="subjectPropertyZip" [(ngModel)]="req.subjectPropertyZip" name="subjectPropertyZip" [mask]="'00000||00000-0000'" />
            </div>
            <div class="form-group mb-5 col-md-6">
              <label class="form-label" for="languagePreference">{{ t('portal.referAFriend.languagePreference') }}</label>
              <select class="form-select" id="languagePreference" [(ngModel)]="req.languagePreference" name="languagePreference"
                (ngModelChange)="onLanguagePreferenceChange()">
                <option [ngValue]="undefined">{{ t('portal.referAFriend.selectOne') }}</option>
                @for (lang of languagePreferenceOptions; track lang.value) {
                  <!-- lang.name is already localized by EnumsService.translateEnumArray, which falls back to
                       the English name when a key is missing. Re-resolving the key here instead (as My Info
                       does) would skip that fallback and render a raw key. -->
                  <option [ngValue]="lang.value">{{ lang.name }}</option>
                }
              </select>
            </div>
            @if (req.languagePreference === 'Other') {
              <div class="form-group mb-5 col-md-6">
                <label class="form-label" for="languagePreferenceOtherDescription">{{ t('portal.referAFriend.specifyLanguage') }}</label>
                <!-- maxlength mirrors the Api's NVARCHAR(100) so the form cannot produce a 422. -->
                <input type="text" class="form-control" id="languagePreferenceOtherDescription"
                  [(ngModel)]="req.languagePreferenceOtherDescription" name="languagePreferenceOtherDescription"
                  [placeholder]="t('portal.referAFriend.specifyLanguage')" maxlength="100" />
              </div>
            }
          }
          <div class="d-flex justify-content-end">
            <button class="btn btn-sm bp-primary-bg-color" type="button" (click)="submit()" [disabled]="isSaving">
              {{ t('portal.referAFriend.submit') }}
            </button>
          </div>
        </div>
      </div>
    </form>
    @if (portalContent?.showReferralTerms) {
      <div class="d-flex justify-content-end m-2 px-6 mb-6">
        <a class="nav-link bp-link dashed-link fw-bold px-0" (click)="termsOpened = !termsOpened">{{ t('portal.referAFriend.termsAndConditions') }}</a>
      </div>
    }
    @if (termsOpened) {
      <div class="mx-6 mb-6" [innerHtml]="sanitizedReferralTermsContent"></div>
    }
  </div>
</div>
</ng-container>
